
import axios from 'axios'
import currencyMockApi from '@/api/mock/currencyMockApi'
const url = process.env.API_CURRENCY_URL

const currencyApi = {
  getCurrencies () {
    return axios.get(`${url}/lb`) // more providers available for example m5
      .catch(function (error) {
        console.error(error)
      })
  }
}

let api = currencyApi
try {
  const useMock = process.env.NODE_ENV === 'development' && process.env.API_USE_MOCK === true
  api = useMock ? currencyMockApi : currencyApi
} catch (e) {
  console.error('error!')
}

export default api



// WEBPACK FOOTER //
// ./src/api/currencyApi.js